"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ErrorTypes = require("../../constants/ErrorTypes");

var _Grader = require("../../selectors/Grader");

var I18N_KEY = 'error';

var targetPageErrorSubtitle = function targetPageErrorSubtitle(domain) {
  return _react.default.createElement(_FormattedHTMLMessage.default, {
    message: I18N_KEY + ".subtitles.targetPageError",
    options: {
      domain: domain
    }
  });
};

var websiteGraderErrorSubtitle = _react.default.createElement(_FormattedHTMLMessage.default, {
  message: I18N_KEY + ".subtitles.websiteGraderError"
});

var ErrorDetails = function ErrorDetails() {
  var _useParams = (0, _reactRouterDom.useParams)(),
      errorType = _useParams.errorType;

  var subtitle;

  switch (errorType) {
    case _ErrorTypes.DOMAIN_INVALID:
    case _ErrorTypes.TARGET_PAGE_ERROR:
      subtitle = targetPageErrorSubtitle((0, _reactRedux.useSelector)(_Grader.getDomain));
      break;

    default:
      subtitle = websiteGraderErrorSubtitle;
      break;
  }

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "main-error-text"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: I18N_KEY + ".title"
  })), _react.default.createElement("div", {
    className: "error-subtitle"
  }, subtitle));
};

var _default = ErrorDetails;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/ErrorDetails.js
// module id = 244
// module chunks = 0